import React, { useEffect, useState } from "react";
import { Modal, Select, message, Typography, Divider, Button } from "antd";
import ApiService from "../../Components/apiService";
import { BASE_URL } from "../../Components/Constant";
import dayjs from "dayjs";
const AddProjectModal = ({ setUnsavedChanges,visible, onClose, setRows, projects, rows }) => {
  const [selected, setSelected] = useState([]);
  const [availableProjects, setAvailableProjects] = useState([]);
  useEffect(() => {
    if (visible) {
      setSelected([]);
      const existingProjectIds = rows?.map(r => r.assignmentId);
      const filtered = projects.filter(p => !existingProjectIds.includes(p.Assignment));
      console.log('rows:', rows);
      console.log('projects:', projects);
      setAvailableProjects(filtered);
    }
  }, [visible, rows, projects]);

  const handleAdd = () => {
    if (!selected.length) {
      message.warning("Please select at least one project");
      return;
    }
    setRows(prev => [
      ...prev,
      ...selected.map(id => {
        const p = projects.find(p => p.Assignment === id);
        console.log("Adding project to timesheet:", p);
        return {
          projectId: p._id,
          projectName: p.Name,
          assignmentId: p.Assignment || null,
          assignmentName: p.AssignmentName || "",
          assignmentStart: p.AssignmentStart || null,
          assignmentEnd: p.AssignmentEnd || null,
          timesheetId: null,
          isBillable: p.IsBillable || false,
          entries: {},
          status: "Draft",
          isSelectedForApproval: false
        };
        
      }),
    ]);
    setUnsavedChanges(true);
    setSelected([]);
    onClose();
  };

  return (
    <Modal
      open={visible}
      onCancel={() => {
        setSelected([]);
        onClose();
      }}
      zIndex={1001}
      footer={null}
      title="Add Projects"
      width={600}
      centered
      bodyStyle={{
        maxHeight: "70vh",
        overflowY: "auto",
        padding: "20px 24px",
      }}
    >
      <Typography.Text strong>Select Assignments</Typography.Text>
      <Divider style={{ margin: "12px 0" }} />

      <Select
        mode="multiple"
        style={{ width: "100%" }}
        placeholder="Select Assignments"
        value={selected}
        onChange={setSelected}
        options={availableProjects?.map((p) => ({
          value: p.Assignment,
          label: `${p.Name} — ${p.AssignmentName || "No Assignment"} - ${p.billing_type} (${dayjs(p.AssignmentStart).format("DD MMM YYYY")} → ${dayjs(p.AssignmentEnd).format("DD MMM YYYY")})`
        }))}
                showSearch
        optionFilterProp="label"
        maxTagCount="responsive"
        size="large"
        dropdownStyle={{ maxHeight: 300, overflowY: "auto" }}
      />

      <Divider style={{ margin: "16px 0" }} />

      <div
        style={{
          display: "flex",
          justifyContent: "flex-end",
          gap: 10,
          marginTop: 8,
        }}
      >
        <Button onClick={onClose}>Cancel</Button>
        <Button type="primary" onClick={handleAdd}>
          Add Selected ({selected.length})
        </Button>
      </div>
    </Modal>
  );
};

export default AddProjectModal;
